import { ApplicationEnvironmentConfiguration } from '@environments/environment';

export const configuration: ApplicationEnvironmentConfiguration = {
  production: false,
  redirectUri: 'https://um.xbp.gls-group.net',
  postLogoutUrl: 'https://um.xbp.gls-group.net',
  baseUrl: 'https://api.gls-group.net',
  authorities: {
    signUpSignInB2C: {
      authority:
        'https://glsgroup.b2clogin.com/glsgroup.onmicrosoft.com/B2C_1A_USERMANAGEMENT_SIGNUP_SIGNIN',
      clientId: '9d9e44e4-5ead-400e-b2fa-acd083a72539',
      tenantId: '02194c84-c4db-4603-b458-d38c5ceb1899',
    },
    signUpSignInAD: {
      authority:
        'https://login.microsoftonline.com/e6170c30-202d-4926-b525-b8b882873f3b',
      clientId: '6b0b111c-c337-4c5d-9309-9cd03c019ef0',
      tenantId: 'e6170c30-202d-4926-b525-b8b882873f3b',
    },
  },
  authorityDomain: 'https://glsgroup.b2clogin.com',
  apiProductNames: {
    CUSTOMS_CONSIGNMENTS_V3: 'customs-consignments-prod-v3',
  },
};
